import { queryStringify } from "../utils/index.js";
import axiosConfig from "../config/axios.js";
import {pages} from "../config/pages.js";

let AXIOS_INIT = false

export default {
  data() {
    return {
      winPageData: window.WinPageData,
    }
  },
  created() {
    if (!AXIOS_INIT) {
      axiosConfig.call(this)
      AXIOS_INIT = true
    }
  },
  computed: {
    isDevEnv() {
      return process.env.NODE_ENV == 'development'
    }
  },
  methods: {
    goPage(name, queryObj = {}, isOpen = true) {
      let _queryObj = Object.assign({}, queryObj)
      let hashObj = null
      if (_queryObj.hash) {
        hashObj = _queryObj.hash
        delete _queryObj.hash
      }
      let url = pages.getUrl(name, _queryObj)
      if(hashObj) {
        let hashStr = queryStringify(hashObj).replace('&', '#')
        url += hashStr
      }
      if (isOpen) {
        window.open(url)
      } else {
        window.location.href = url
      }
    },
    goHashPage(name, queryObj = {}, isOpen = true) {
      const url = pages.getUrl(name, queryObj)
      if (isOpen) {
        window.open(url)
      } else {
        window.location.href = url
      }
    }
  }
}



// WEBPACK FOOTER //
// ./pc/index/mixins/index.js